<template>
  <span>
    {{ content }}
  </span>
</template>

<script>
import { format as priceFormat } from '@/utils/number';
export default {
  name: 'BidsAddBulkPricingTablePriceOfferColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    content() {
      const { priceOffer } = this.row;
      if (!priceOffer) {
        return this.$t('NOT_SPECIFIED');
      }
      return `${priceFormat(priceOffer)} ${this.$t('RIALS')}`;
    },
  },
  methods: {
    priceFormat,
  },
};
</script>
